var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 32,
    viewBox: "0 0 98 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aVisaa{fill:#fff;}.bVisaa{fill:#fb9800;}.bVisaa,.cVisaa{fill-rule:evenodd;}.cVisaa{fill:#004487;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aVisaa",
    width: 98,
    height: 62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-195 -52.639)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bVisaa",
    d: "M221.234,179.322a93.028,93.028,0,0,1,57.873-5.814l.265-6.4c-26.627-2.908-45.732,5.572-58.138,11.583v.631Z",
    transform: "translate(-6.196 -74.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cVisaa",
    d: "M258.751,123.891l5.886-19.407h5.252L264,123.891Z",
    transform: "translate(-29.511 -36.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cVisaa",
    d: "M225.176,104.5l-4.724,8.227a19.929,19.929,0,0,0-2.244,4.6h-.072c.084-1.726-.157-3.845-.18-5.043l-.522-7.788h-8.84l-.091.522a3.665,3.665,0,0,1,3.989,3.475l1.723,15.405h5.441l11-19.4Z",
    transform: "translate(1.715 -36.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cVisaa",
    d: "M337.871,123.952l-.145-2.886-6.558-.005-1.341,2.891h-5.7l10.339-19.37h7l1.75,19.37Zm-.6-11.448a44.418,44.418,0,0,1-.009-4.559h-.078c-.319.963-1.692,3.856-2.3,5.279l-1.954,4.254h4.6l-.267-4.974Z",
    transform: "translate(-70.139 -36.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cVisaa",
    d: "M289.728,123.743a14.684,14.684,0,0,1-7.925-2.224l2.5-3.821c1.577.882,2.815,1.9,5.664,1.9a2.437,2.437,0,0,0,2.3-1.106c.73-1.262-.168-1.942-2.22-3.1l-1.013-.659c-3.042-2.078-4.357-4.052-2.925-7.5.916-2.2,3.332-3.874,7.318-3.874a11.762,11.762,0,0,1,6.828,2.351l-2.876,3.373a6.389,6.389,0,0,0-4.07-1.785,2.448,2.448,0,0,0-2.241,1c-.547,1.084.177,1.822,1.775,2.814l1.2.767c3.692,2.329,4.572,4.77,3.646,7.053-1.592,3.93-4.708,4.807-7.968,4.807Z",
    transform: "translate(-43.837 -35.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cVisaa",
    d: "M375.892,107.508h-.346v-2.1h.8c.508,0,.768.178.768.6a.538.538,0,0,1-.549.574l.589.925h-.391l-.543-.9h-.326v.9Zm.387-1.194c.259,0,.488-.025.488-.33,0-.254-.249-.285-.458-.285h-.417v.615Zm-.011,2.007a1.9,1.9,0,1,1,1.86-1.9,1.829,1.829,0,0,1-1.86,1.9Zm0-3.471a1.575,1.575,0,1,0,1.454,1.57,1.475,1.475,0,0,0-1.454-1.57Z",
    transform: "translate(-101.381 -36.243)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0f948f5b626c287d401d735882b94391.svg";
export { ForwardRef as ReactComponent };